.popover {
	display: flex;
	flex-direction: column;
	min-height: 0;
	padding: var(--size-4);
	gap: var(--size-4);
	width: 18rem;
}
